import React from "react";
import TextField from "@material-ui/core/TextField";
import Utils from "./utils";
import Button from "@material-ui/core/Button";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableHead from "@material-ui/core/TableHead";
//
// // import OutlinedInput from "@material-ui/core/OutlinedInput";
// import TableRow from "@material-ui/core/TableRow";
// import InputLabel from "@material-ui/core/InputLabel";
// import Select from "@material-ui/core/Select";
// import FormControl from "@material-ui/core/FormControl";
// Font registration removed - using PDFKit now
class IndividualTransaction extends React.Component {

  constructor(props) {
    super(props);
    this.state = props.location.state.trx;
    // this.state = {
    //   docnumber: props.trx.invoicenumber,
    //   transaction: props.trx.transactionnumber,
    //   status: "",
    //   items: props.trx.products.items,
    //   patientname: props.trx.patientname,
    //   icd10: props.trx.icd10,
    //   medicalaidname: props.trx.medicalaidname,
    //   medicalaidnumber: props.trx.medicalaidnumber,
    //   date: new Date(props.trx.date).toDateString(),
    //   invoicenumber: props.trx.invoicenumber,
    //   receiptnumber: props.trx.receiptnumber,
    //   disableinvoice: true,
    //   disablereceipt: true,
    //   totalvalue: props.trx.totalvalue
    // };
  }

  async downloadPDF(blob, filename) {
    // Create download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  async generateAndDownloadPDF(documentType = 'RECEIPT') {
    try {
      // Prepare the data for the lambda
      const requestData = {
        items: (this.state.products && this.state.products.items) || [],
        patient: this.state.patientname,
        icd: this.state.icd10,
        medicalaidname: this.state.medicalaidname,
        medicalaidnumber: this.state.medicalaidnumber,
        date: this.state.date,
        invoicenumber: this.state.invoicenumber,
        receiptnumber: this.state.receiptnumber,
        documentType: documentType
      };

      const response = await fetch('https://4qy64aunwvjpd4j7kcqotc5ohi0kevuo.lambda-url.eu-west-1.on.aws/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      if (response.ok) {
        const blob = await response.blob();
        const filename = `${documentType.toLowerCase().replace(' ', '_')}_${this.state.receiptnumber || this.state.invoicenumber}.pdf`;
        await this.downloadPDF(blob, filename);
      } else {
        const errorData = await response.text();
        alert(`Error generating PDF: ${errorData}`);
      }
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  }

  add2hrs(inputdate) {
    inputdate = new Date(inputdate);
    inputdate.setHours(inputdate.getHours() + 2);
    return inputdate;
  }

  render() {
    return (
      <div style={{ margin: 2 }}>
        <TextField
          id="date"
          label="Override Date"
          type="date"
          value={this.add2hrs(this.state.date).toISOString().substring(0, 10)}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(change) => {
            var newdate = this.add2hrs(
              new Date(change.target.value)
            ).toDateString();

            this.setState({ date: newdate });
          }}
        />
        <Button
          style={{ margin: 2 }}
          variant="contained"
          color="primary"
          onClick={() => this.generateAndDownloadPDF('RECEIPT')}
        >
          Download Receipt
        </Button>
      </div>
    );
  }
}

export default IndividualTransaction;